// export const WHITE_LIST = [
//   { name: 'notFound', children: [] },
//   { name: 'login', children: [] },
// ];

// export const NOT_FOUND = {
//   name: 'notFound',
// };
export const REDIRECT_ROUTE_NAME = 'Redirect';

export const DEV_ROUTE_NAME = 'TemporaryTemplate';

// export const DEFAULT_ROUTE_NAME = 'GoodsPlan';
// export const DEFAULT_ROUTE = {
//   title: '商品企划',
//   name: DEFAULT_ROUTE_NAME,
//   fullPath: '/develop/goods-plan',
// };

// export const DEFAULT_ROUTE_NAME_PRO = 'GoodsPlanPro';
// export const DEFAULT_ROUTE_PRO = {
//   title: '商品企划',
//   name: DEFAULT_ROUTE_NAME_PRO,
//   fullPath: '/develop-pro/goods-plan-pro',
// };
export const DEFAULT_ROOT_ROUTE_NAME = 'Home';
export const DEFAULT_ROUTE_NAME = 'HomePage';
export const DEFAULT_ROUTE = {
  title: '首页',
  name: DEFAULT_ROUTE_NAME,
  fullPath: '/home/index',
};
export const NOT_FOUND_ROUTE_NAME = 'notFound'; // 无权限页面

export const SUPPLIER_LOGIN_REDIRECT_ROUTE_NAME = 'SupplierLoginRedirect'; // 用于标记state，给微信扫码登录后服务器的重定向判断
export const DEFAULT_SUPPLIER_ROUTE_NAME = 'ProductionOrderForFactory'; // 加工厂系统的默认首页
export const NOT_BOUND_CLIENT_ROUTE_NAME = 'NotBoundClient'; // 没绑定品牌方的路由
export const SUPPLIER_LOGIN_ROUTE_NAME = 'SupplierLogin'; // 加工厂登录的路由
// 加工厂登录
export const SUPPLIER_LOGIN_ROUTE = {
  name: SUPPLIER_LOGIN_ROUTE_NAME,
};
